import type { FiltersDefinition } from '@factorialco/f0-react'

import { FilterKeys } from 'modules/shift_management/hooks/reducers/filter'
import type { SelectableEmployee } from 'modules/shift_management/hooks/useSelectableEmployees'

interface BuildFiltersDefinitionProps {
  selectableEmployees: SelectableEmployee[]
  teams: Array<{ label: string; value: string }>
  employeeStatuses: Array<{ label: string; value: string }>
  status: Array<{ label: string; value: string }>
  legalEntities: Array<{ label: string; value: string }>
  workAreas: Array<{ label: string; value: string }>
  locations: Array<{ label: string; value: string }>
  filterKeys: Record<FilterKeys, string>
}
export const buildFiltersDefinition = ({
  selectableEmployees,
  teams,
  employeeStatuses,
  status,
  legalEntities,
  workAreas,
  locations,
  filterKeys,
}: BuildFiltersDefinitionProps): FiltersDefinition<string> => {
  return {
    [filterKeys.employees]: {
      label: filterKeys.employees,
      type: 'in',
      options: {
        options: selectableEmployees.map((e) => ({
          label: e.fullName,
          value: e.id,
        })),
        cache: true,
      },
    },
    [filterKeys.teams]: {
      label: filterKeys.teams,
      type: 'in',
      options: { options: teams, cache: true },
    },
    [filterKeys.status]: {
      label: filterKeys.status,
      type: 'in',
      options: { options: status, cache: true },
    },
    [filterKeys.employee_status]: {
      label: filterKeys.employee_status,
      type: 'in',
      options: { options: employeeStatuses, cache: true },
    },
    [filterKeys.legal_entities]: {
      label: filterKeys.legal_entities,
      type: 'in',
      options: { options: legalEntities, cache: true },
    },
    [filterKeys.shift_work_areas]: {
      label: filterKeys.shift_work_areas,
      type: 'in',
      options: { options: workAreas, cache: true },
    },
    [filterKeys.shift_locations]: {
      label: filterKeys.shift_locations,
      type: 'in',
      options: { options: locations, cache: true },
    },
  }
}
